import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(theme => ({
  uploadButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    border: `1px solid ${C.reviewBorder}`,
    background: C.cardBg,
    cursor: 'pointer',
    '& svg': { fontSize: 12, color: C.darkText },
  },
  uploadLabel: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: C.darkText,
  },
  empty: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    width: '100%',
  },
  docPill: {
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    maxWidth: '100%',
    minWidth: 0,
    padding: theme.spacing(0.5, 1, 0.5, 2),
    borderRadius: 8,
    border: `1px solid ${C.metricBorder}`,
    background: C.metricBg,
    textDecoration: 'none',
    '& svg': { fontSize: 14, color: C.mutedText, flexShrink: 0 },
  },
  filename: {
    // Long S3-derived names would stretch a chip across the whole card;
    // EllipsisText clips at this width and reveals the rest on hover.
    maxWidth: theme.spacing(25),
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.strongText,
  },
  // Sits inside the document pill, so it needs its own ground to read as a pill
  // rather than dissolving into the one around it.
  useCase: {
    flexShrink: 0,
    padding: theme.spacing(0.25, 1),
    borderRadius: 12,
    background: C.cardBg,
    border: `1px solid ${C.metricBorder}`,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: C.mutedText,
    whiteSpace: 'nowrap',
  },
  paper: {
    boxSizing: 'border-box',
    width: theme.spacing(60),
    maxWidth: '92vw',
    borderRadius: 8,
    padding: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%',
  },
  dialogTitle: {
    fontSize: 22,
    fontWeight: 400,
    lineHeight: '28px',
    color: C.strongText,
  },
  close: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 0,
    '& svg': { fontSize: 24, color: C.mutedText },
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    width: '100%',
  },
  filePicker: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    borderRadius: 8,
    border: `1px dashed ${C.buttonBorder}`,
    background: C.cardBg,
    cursor: 'pointer',
    '& svg': { fontSize: 16, color: C.mutedText },
  },
  filePickerLabel: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.strongText,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  helper: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: C.mutedText,
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    width: '100%',
    marginTop: theme.spacing(1),
  },
  fieldLabel: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: C.labelText,
  },
  select: {
    boxSizing: 'border-box',
    width: '100%',
    height: theme.spacing(5),
    padding: theme.spacing(0, 1.5),
    borderRadius: 4,
    border: `1px solid ${C.buttonBorder}`,
    background: C.cardBg,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.strongText,
    outline: 'none',
    cursor: 'pointer',
    '&:focus': { borderColor: C.linkBlue },
  },
  dialogFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(3),
    width: '100%',
  },
  spinner: {
    marginRight: theme.spacing(1),
    color: C.strongText,
  },
  button: {
    boxSizing: 'border-box',
    height: theme.spacing(5),
    padding: theme.spacing(1.25, 3),
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.strongText,
  },
  cancelButton: {
    backgroundColor: C.cardBg,
    border: `1px solid ${C.stepUpcomingBorder}`,
  },
  confirmButton: {
    backgroundColor: C.bannerBorder,
    border: 'none',
    '&:disabled': { opacity: 0.5, cursor: 'not-allowed' },
  },
}))
